module.exports = __webpack_public_path__ + "static/media/plus-icon-disabled.284381f4.svg";